import { getAssetsTypesAssociatedWithProject } from '../project';
import { AI_SUGGESTION_MODE } from './const';
import { getAvailableSuggestionModes } from './getAvailableSuggestionModes';

export const isProjectTypeSupportCustomTemplates = (projectType, briefType) => {
  if (!projectType || !briefType) {
    return false;
  }

  const project = { type: projectType, brief: { type: briefType } };
  const assetTypes = getAssetsTypesAssociatedWithProject(project);

  return assetTypes.some((assetType) => {
    const availableCommonModes = getAvailableSuggestionModes(
      projectType,
      assetType,
      briefType
    );
    return availableCommonModes.includes(AI_SUGGESTION_MODE.guided);
  });
};
